module.exports = __webpack_public_path__ + "static/media/26UNRWA13.645ff6cc.jpg";